const HTTP_URL = /^https?:\/\/\S+$/i;

/**
 * The one rule for external URLs: only http(s) is accepted by the form and
 * rendered as a link. The API doesn't validate the scheme, so anything else
 * (e.g. `javascript:`) must be shown as text, never put in an href.
 */
export const isHttpUrl = (value: string): boolean =>
  HTTP_URL.test(value.trim());
